// Helper for BreadcrumbList JSON-LD injection across internal routes.
// Returns a script descriptor compatible with TanStack Start route head().
import { jsonLdScript } from "@/lib/jsonld";

const BASE = "https://onlinetaxvat.com";

export function breadcrumbScript(trail: Array<{ name: string; path: string }>) {
  return jsonLdScript({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: trail.map((t, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: t.name,
      item: t.path.startsWith("http") ? t.path : `${BASE}${t.path}`,
    })),
  });
}
